<template>
  <div>
    <BListFilter
      v-model="form"
      :skeleton="skeleton"
      label="Поиск по логину и имени"
      dense
      @change="onChangeDebounced"
    />

    <v-row dense>
      <v-col :cols="!skeleton && 'auto'">
        <BTextField
          v-model="form.user_id"
          :skeleton="skeleton"
          validate="numeric"
          label="ID пользователя"
          placeholder="Введите ID"
          @input="onChangeDebounced"
        />
      </v-col>

      <v-col :cols="!skeleton && 'auto'">
        <BTextFieldDate
          v-model="form.date_great"
          :skeleton="skeleton"
          :max="form.date_less || new Date()"
          label="Дата больше или равна"
          placeholder="Дата изменения"
          @input="onChangeDebounced"
        />
      </v-col>

      <v-col :cols="!skeleton && 'auto'">
        <BTextFieldDate
          v-model="form.date_less"
          :skeleton="skeleton"
          :min="form.date_great"
          :max="new Date()"
          label="Дата меньше или равна"
          placeholder="Дата изменения"
          @input="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextFieldDate from '@/components/forms/BTextFieldDate.vue'


const createDefaultDataUsersHistory = () => ({
  ...createDefaultData(),
  user_id: null,
  date_great: null,
  date_less: null,
})

export default {
  name: 'UsersHistoryFilter',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BListFilter,
    BTextField,
    BTextFieldDate,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataUsersHistory,
    },
  },
}
</script>
